class SubscriptionFlow extends HTMLElement {
    constructor() {
      super();
      document.addEventListener('DOMContentLoaded',() => {
        this.init();
        this.bindEvents();
      });
    }
    init(){
      this.bagQuantity = 2;
      this.currentPlaylistHandle = this.getAttribute('data-playlist-handle').trim();
      this.currentPlaylistName = this.getAttribute('data-playlist-name') || "";
      this.verticalSlider = this.querySelector('custom-vertical-slider');
  
      // frequency step container
      this.frequencyStepContainer = this.querySelector('[data-frequency-step]');
  
      // brew type step container
      this.roastType = null
      this.brewTypeStepContainer = this.querySelector('[data-brew-type-step]');
      this.brewTypeSelectionData = { espresso: null, filter: null };
      this.rangeInput = this.querySelector('[data-range-input]');
  
      // grind Selection Object
      this.grindSelectionObject = { filter:"whole-bean", espresso:"whole-bean" };
  
  
      this.grindPreferencesStepContainer = this.querySelector('[data-grind-preferences-step]');
      this.grindPreferences = { consent: null, filter: null, espresso: null, whole_bean: null };
      this.summaryStepContainer = this.querySelector('[data-summary-step]');
      this.completedSteps = [];
      this.collectionId = this.getAttribute('data-collection-id');
      this.backButton = this.querySelector('[data-back-button]');
      this.volumeDiscount = {
        "2": 5,
        "3": 10,
        "4": 15,
        "5": 18,
      }
      this.checkoutPlaylistButton = this.querySelectorAll('[data-checkout-playlist-button]');
      this.swapPlaylistContainer = this.querySelector('[data-swap-playlist-container]');
      this.swapHeaderBack = this.swapPlaylistContainer.querySelector('[data-swap-header-back]');
      this.quantityStepContainer = this.querySelector('[data-quantity-step]');
      this.swapPlaylistButton = this.querySelector('[data-swap-playlist-button]');
    }
    bindEvents() {
      console.log("connectedCallback");
      // quantity step handler
      if (this.quantityStepContainer) {
        this.quantityStepContainer.querySelectorAll('input').forEach(input => {
          // input.addEventListener('change', this.handleQuantityStepChange.bind(this));
          input.addEventListener('click', this.handleQuantityStepChange.bind(this));
        });
      }
  
      this.backButton.addEventListener('click',() => {
        this.verticalSlider.handlePreviousSlide();
      });
      if(this.swapPlaylistButton){
        this.swapPlaylistButton.addEventListener('click',() => {
          this.swapPlaylistContainer.classList.add('swap-active');
          this.swapPlaylistContainer.querySelectorAll('[data-swap-block]').forEach(item => {
            item.classList.remove('swap-selected');
          });
          this.swapPlaylistContainer.querySelector(`[data-playlist-handle="${this.currentPlaylistHandle}"]`).classList.add('swap-selected');
          this.swapPlaylistContainer.querySelector(`[data-swap-action]`).disabled = true;
          this.swapPlaylistContainer.querySelector(`[data-swap-action]`).classList.add('hidden');
          this.classList.add('swap-opened');
          this.swapPlaylistContainer.querySelectorAll('[data-swap-block]').forEach(item => {
            const playlistHandle = item.getAttribute('data-playlist-handle');
            if(playlistHandle == "mixtape"){
              const{discountedPrice,totalProductPrice} = playlistUtilities.getDynamicBundleSelection(playlistHandle,parseInt(this.bagQuantity),this.tagWithCount,this.frequency.value);
              item.querySelectorAll(`[data-swap-item-discounted-price]`).forEach(item => {
                item.innerHTML = theme.Currency.formatMoney(discountedPrice,theme.settings.moneyFormat);
              });
              item.querySelectorAll(`[data-swap-item-price]`).forEach(item => {
                item.innerHTML = theme.Currency.formatMoney(totalProductPrice,theme.settings.moneyFormat);
              });
            }
            else{
              const{discountedPrice,totalProductPrice} = playlistUtilities.getStaticBundleSelection(playlistHandle,parseInt(this.bagQuantity),this.tagWithCount,this.frequency.value);
              item.querySelectorAll(`[data-swap-item-discounted-price]`).forEach(item => {
                item.innerHTML = theme.Currency.formatMoney(discountedPrice,theme.settings.moneyFormat);
              });
              item.querySelectorAll(`[data-swap-item-price]`).forEach(item => {
                item.innerHTML = theme.Currency.formatMoney(totalProductPrice,theme.settings.moneyFormat);
              });
            }
          });
        });
      }
      if(this.swapHeaderBack){
        this.swapHeaderBack.addEventListener('click',() => {
          this.swapPlaylistContainer.classList.remove('swap-active');
          this.classList.remove('swap-opened');
        });
      }
      if(this.swapPlaylistContainer){
        this.swapPlaylistContainer.querySelectorAll('[data-swap-block]').forEach(item => {
          item.addEventListener('click',() => {
            const playlistHandle = item.getAttribute('data-playlist-handle');
            if(this.currentPlaylistHandle == playlistHandle){
              this.swapPlaylistContainer.querySelector('[data-swap-action]').disabled = true;
              this.swapPlaylistContainer.querySelector('[data-swap-action]').classList.add('hidden');
            }
            else{
              this.swapPlaylistContainer.querySelector('[data-swap-action]').disabled = false;
              this.swapPlaylistContainer.querySelector('[data-swap-action]').classList.remove('hidden');
            }
            this.swapPlaylistContainer.querySelectorAll('[data-swap-block]').forEach(item => {
              item.classList.remove('swap-selected');
            });
            item.classList.add('swap-selected');
            this.swapSelectedPlaylistHandle = playlistHandle;
          });
        });
        this.swapPlaylistContainer.querySelector('[data-swap-action]').addEventListener('click',() => {
          console.log(this.swapSelectedPlaylistHandle,"this.swapSelectedPlaylistHandle");
          this.setAttribute('data-playlist-handle',this.swapSelectedPlaylistHandle);
          this.currentPlaylistHandle = this.swapSelectedPlaylistHandle;
          this.swapPlaylistContainer.classList.remove('swap-active');
          this.classList.remove('swap-opened');
          this.swapPlaylistContainer.querySelectorAll('[data-swap-block]').forEach(item => {
            item.classList.remove('swap-selected');
          });
          this.swapPlaylistContainer.querySelector('[data-swap-action]').classList.add('hidden');
          document.querySelector('subscription-modal').setAttribute('data-playlist-name',this.swapSelectedPlaylistHandle);
          this.classList.remove('swap-selected');
  
          this.prepareSummary();
        });
      }
    
      if (this.frequencyStepContainer) {
        this.frequencyStepContainer.querySelectorAll('input').forEach(input => {
          // input.addEventListener('change', this.handleFrequencyStepChange.bind(this));
          input.addEventListener('click', this.handleFrequencyStepChange.bind(this));
        });
      }
      if (this.brewTypeStepContainer) {
        this.brewTypeStepContainer.querySelector('.subscription-flow-body-main-content').querySelectorAll('input').forEach(input => {
          // input.addEventListener('change', this.handleBrewTypeStepChange.bind(this));
          input.addEventListener('click', this.handleBrewTypeStepChange.bind(this));
        });
        this.rangeInput.addEventListener('input', this.handleRangeInputChange.bind(this));
        this.querySelector('[data-next-step]').addEventListener('click', (e) => {
          const slideIndex = parseInt(e.target.closest('[data-slide]').getAttribute('data-slide-index'));
          
          this.completedSteps.push(slideIndex);
          this.verticalSlider.handleNextSlide();
          this.prepareSummary();
        });
      }
      if (this.grindPreferencesStepContainer) {
        const consentStep = this.grindPreferencesStepContainer.querySelector('[data-grind-preferences-consent-step]');
        consentStep.querySelectorAll('input').forEach(input => {
          // input.addEventListener('input', this.handleGrindPreferencesConsentStepChange.bind(this));
          input.addEventListener('click', this.handleGrindPreferencesConsentStepChange.bind(this));
        });
        const filterStep = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-espresso-step]');
        filterStep.querySelectorAll('input').forEach(input => {
          // input.addEventListener('change', this.handleGrindFilterEspressoStepChange.bind(this));
          input.addEventListener('click', this.handleGrindFilterEspressoStepChange.bind(this));
        });
      }
      if (this.querySelectorAll('[data-edit-step]').length > 0) {
        this.querySelectorAll('[data-edit-step]').forEach(item => {
          item.addEventListener('click', (e) => {
            const stepName = e.target.getAttribute('data-edit-step');
            const slideIndex = Array.from(this.verticalSlider.slides).findIndex(slide => slide.getAttribute('data-slide-type') == stepName);
            this.verticalSlider.goToSlide(slideIndex);
          });
        });
      }
      if(this.checkoutPlaylistButton){
        this.checkoutPlaylistButton.forEach(item => {
          item.addEventListener('click',async (e) => {
          e.preventDefault();
          if(window.cartHelper.isBundleInCart()){
            window.notificationEle.updateNotification('Add to Cart', 'You can only have one bundle in cart at a time', {
              type: 'info',
              timeout: 10000
            });
            return;
          }
          if(window.customerHasSubscribedPlaylist){
            window.notificationEle.updateNotification('Add to Cart', 'You are already subscribed to a playlist. You can subscribe, swap, edit and manage your subscription in My Account', {
              type: 'info',
              timeout: 10000
            });
            return;
          }
          if(e.target.tagName == "BUTTON"){
            e.target.setAttribute('aria-busy', 'true');
            e.target.setAttribute('aria-disabled', 'true');
          }
          else{
            e.target.closest('button').setAttribute('aria-busy', 'true');
            e.target.closest('button').setAttribute('aria-disabled', 'true');
          }
          if(this.currentPlaylistHandle == "mixtape"){
            await this.addTocartDynamicPlaylist(e);
          }
          else{
           await this.addTocartStaticPlaylist(e);
          }
          });
        });
      }
    }

    async addTocartStaticPlaylist(e){
      const isValid = await recharge.bundle.validateBundle(this.bundleObject);
      const rbId = await recharge.bundle.getBundleId(this.bundleObject);
      const subscriptionProperties = subscriptionHelper.subscriptionPropertiesFormatted(this.getProperties());
      
      
      console.log(subscriptionProperties,"subscriptionProperties");
        if(isValid && rbId){
          const cartData = {
            items: [
              {
                id: this.bundleObject.externalVariantId,
                quantity: 1,
                selling_plan: this.sellingPlan,
                properties: { _rb_id: rbId ,_subscriptionData: JSON.stringify(subscriptionProperties)},
              },
            ],
            attributes:{_subscriptionData: JSON.stringify(subscriptionProperties)},
          };
          try {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cartData),
              })
              .then(response => {
                console.log(response,"response");
                const subscriptionModal = document.querySelector('subscription-modal');
                subscriptionModal.hide();
                if(e.target.tagName == "BUTTON"){
                  e.target.setAttribute('aria-busy', 'false');
                  e.target.setAttribute('aria-disabled', 'true');
                }
                else{
                  e.target.closest('button').setAttribute('aria-busy', 'false');
                  e.target.closest('button').setAttribute('aria-disabled', 'true');
                }
                console.log("add to cart")
                window.location.href = '/checkout';
              }).catch(error => {
                console.log(error,"error");
              });
          }
          catch(error){
            console.log(error,"error");
          }
          finally{
            if(e.target.tagName == "BUTTON"){
              e.target.setAttribute('aria-busy', 'false');
              e.target.setAttribute('aria-disabled', 'false');
            }
            else{
              e.target.closest('button').setAttribute('aria-busy', 'false');
              e.target.closest('button').setAttribute('aria-disabled', 'false');
            }
          }
          
        }
        else{
          // to do error handling
         alert("Bundle is not valid");
        }
    }
    async addTocartDynamicPlaylist(e){
      const isValid = await recharge.bundle.validateBundle(this.bundleObject);
      const subscriptionProperties = subscriptionHelper.subscriptionPropertiesFormatted(this.getProperties());
      console.log(subscriptionProperties,"subscriptionProperties");
      
        if(isValid){
          const cartItems = await recharge.bundle.getDynamicBundleItems(this.bundleObject, this.bundleProduct.handle);
            const cartData = { items: cartItems, attributes:{_subscriptionData: JSON.stringify(subscriptionProperties)} };
          try {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cartData),
              })
              .then(response => {
                console.log(response,"response");
                const subscriptionModal = document.querySelector('subscription-modal');
                subscriptionModal.hide();
                if(e.target.tagName == "BUTTON"){
                  e.target.setAttribute('aria-busy', 'false');
                  e.target.setAttribute('aria-disabled', 'true');
                }
                else{
                  e.target.closest('button').setAttribute('aria-busy', 'false');
                  e.target.closest('button').setAttribute('aria-disabled', 'true');
                }
                  window.location.href = '/checkout';
              }).catch(error => {
                console.log(error,"error");
              });
          }
          catch(error){
            console.log(error,"error");
          }
          finally{
            if(e.target.tagName == "BUTTON"){
              e.target.setAttribute('aria-busy', 'false');
              e.target.setAttribute('aria-disabled', 'false');
            }
            else{
              e.target.closest('button').setAttribute('aria-busy', 'false');
              e.target.closest('button').setAttribute('aria-disabled', 'false');
            }
          }
          
        }
        else{
          // to do error handling
         alert("Bundle is not valid");
        }
    }

    triggerPlaylistFromProduct(bagQuantity,frequency){
      this.bagQuantity = bagQuantity;
      this.quantityStepContainer.querySelector('input[value="'+bagQuantity+'"]').click();
      this.frequency = { value: frequency, type: "weeks" };
      this.frequencyStepContainer.querySelector('input[value="'+frequency+'"]').click();
      this.prepareSummary();
      
    }

    getProperties(){
      let grindPreferenceArray = [];
      let prouducts_sku = [];
      this.selectionProductListing.forEach(item => {
        if(item.tags.includes('espresso')){
          const grind_Value = this.grindSelectionObject.espresso;
          item.variants.forEach((variant)=>{
            if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
              if(variant.sku){
                prouducts_sku.push({sku:variant.sku,grindType:grind_Value});
              }
              grindPreferenceArray.push({variantId:variant.id,grind_Value});
            }
          })
        }
        else{
          const grind_Value = this.grindSelectionObject.filter;
          item.variants.forEach((variant)=>{
            if(variant.title == "300g" || variant.title == "300G" || variant.title == "300 G" || variant.title == "300 g"){
              if(variant.sku){
                prouducts_sku.push({sku:variant.sku,grindType:grind_Value});
              }
              grindPreferenceArray.push({variantId:variant.id,grind_Value});
            }
          })
        }

      })
        return {
            playlist_handle:this.currentPlaylistHandle,
            espresso: this.espressoCount,
            filter: this.filterCount,
            external_collection_id: this.playlistData.collection_id,
            grind_filter: this.grindSelectionObject.filter,
            grind_espresso: this.grindSelectionObject.espresso,
            weight:"300g",
            external_variant_id:this.bundleObject.externalVariantId,
            grind_preference_array:JSON.stringify(grindPreferenceArray),
            products_sku:JSON.stringify(prouducts_sku)
        }
    }
  
    prepareSummary() {
      if (this.summaryStepContainer) {
        // update frequency logic
        if (this.frequency) {
          const frequencyElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-frequency-value]'));
          const frequencyTypeElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-frequency-type]'));
          frequencyElements.forEach(item => {
            item.textContent = this.frequency.value;
          });
          frequencyTypeElements.forEach(item => {
            item.textContent = this.frequency.type;
          });
        }
  
        // prepare roast mix count logic
        const roastMixCountElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-roast-mix-count]'));
        const roastMixTextArray = [];
        this.tagWithCount = { filter: 0, espresso: 0 };
        if (this.espressoCount > 0) {
          roastMixTextArray.push(this.espressoCount + " Espresso");
          this.tagWithCount.espresso = parseInt(this.espressoCount);
        }
        if (this.filterCount > 0) {
          roastMixTextArray.push(this.filterCount + " Filter");
          this.tagWithCount.filter = parseInt(this.filterCount);
        }
        roastMixCountElements.forEach(item => {
          if(this.filterCount > 0 && this.espressoCount > 0){
            item.innerHTML = `<span>Mix of Both</span><span> (${roastMixTextArray.join(", ")})</span>`;
          }else{
            item.innerHTML = `<span>${roastMixTextArray.join(", ")}</span>`;
          }
        });
  
        // update roast type logic
        if (this.roastType) {
          const roastTypeElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-roast-type]'));
          roastTypeElements.forEach(item => {
            item.textContent = this.roastType;
          });
        }
        else {
          const roastTypeElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-roast-type]'));
          roastTypeElements.forEach(item => {
            item.classList.add('hidden');
          });
        }
  
        if (this.grindPreferences && this.grindPreferences.consent == "yes") {
          const grindPreferencesElement = this.summaryStepContainer.querySelector('[data-grind-type]');
          let grindPreferencesList = [];
          Object.entries(this.grindSelectionObject).forEach(([key, value]) => {
            grindPreferencesList.push(value);
          });

          const uniqueGrindPreferencesList = Utility.arrayHelper.removeDuplicates(grindPreferencesList);
          if (grindPreferencesElement) {
            grindPreferencesElement.textContent = Utility.stringHelper.toTitleCase(Utility.stringHelper.formateGrindType(uniqueGrindPreferencesList.join(", ")));
          }
        }
        else {
          let grindPreferencesList = [];
          this.grindPreferences.whole_bean = "whole beans";
          Object.entries(this.grindSelectionObject).forEach(([key, value]) => {
            grindPreferencesList.push(value);
          });
          
          const uniqueGrindPreferencesList = Utility.arrayHelper.removeDuplicates(grindPreferencesList);
          console.log(uniqueGrindPreferencesList,"grindPreferencesList");
          const grindPreferencesElement = this.summaryStepContainer.querySelector('[data-grind-type]');
          if (grindPreferencesElement) {
            grindPreferencesElement.textContent = Utility.stringHelper.toTitleCase(Utility.stringHelper.formateGrindType(uniqueGrindPreferencesList.join(", ")));
          }
        }
      }
      // update playlist discount logic
      this.summaryStepContainer.querySelectorAll('[data-playlist-discount]').forEach(item => {
        item.textContent = this.discountValue + ' %';
      });

      let frequency = "3 weeks";
      if(this.frequency && this.frequency.value && this.frequency.type){
        frequency = this.frequency.value + " " + this.frequency.type.toLowerCase().replace("weeks","week");
      }
      
      

      if(this.currentPlaylistHandle == "mixtape"){
        try{
        const { bundleSelections, bundleObject, bundleProduct, playlistData, totalProductPrice, selectionProductListing, discountedPrice, totalProductCount }= playlistUtilities.getDynamicMultiPlaylistBundleSelection(this.currentPlaylistHandle,parseInt(this.bagQuantity),this.tagWithCount,frequency);
          this.bundleSelections = bundleSelections
          this.bundleObject = bundleObject
          this.bundleProduct = bundleProduct;
          this.totalProductPrice = totalProductPrice
          this.discountedPrice = discountedPrice
          this.selectionProductListing = selectionProductListing
          console.log(bundleSelections,"bundleSelections");
          console.log(this.selectionProductListing,"this.selectionProductListing");
          this.playlistData = playlistData;
        }
        catch(error){
          console.log(error,"error");
          const { bundleSelections, bundleObject, bundleProduct, playlistData, totalProductPrice, selectionProductListing, discountedPrice, totalProductCount }= playlistUtilities.getDynamicBundleSelection(this.currentPlaylistHandle,parseInt(this.bagQuantity),this.tagWithCount,frequency);
          this.bundleSelections = bundleSelections
          this.bundleObject = bundleObject
          this.bundleProduct = bundleProduct;
          this.totalProductPrice = totalProductPrice
          this.discountedPrice = discountedPrice
          this.selectionProductListing = selectionProductListing
          console.log(bundleSelections,"bundleSelections");
          console.log(this.selectionProductListing,"this.selectionProductListing");
          this.playlistData = playlistData;
        }
      }
      else{
        const { bundleSelections,bundleObject,playlistData, totalProductPrice, selectionProductListing, discountedPrice ,bundleProduct ,sellingPlan} = playlistUtilities.getStaticBundleSelection(this.currentPlaylistHandle,parseInt(this.bagQuantity),this.tagWithCount,frequency);
        this.bundleSelections = bundleSelections;
        this.bundleObject = bundleObject;
        this.bundleProduct = bundleProduct;
        this.sellingPlan = sellingPlan;
        this.totalProductPrice = totalProductPrice;
        this.discountedPrice = discountedPrice;
        this.selectionProductListing = selectionProductListing;
        this.sellingPlan = sellingPlan;
        this.playlistData = playlistData;
        
        
      }

      this.summaryStepContainer.querySelectorAll('[data-playlist-price]').forEach(item => {
        item.textContent = this.totalProductPrice;
      });
      this.selectionProductObject = this.bundleSelections;
      if(this.completedSteps.includes(3)){
        this.intSlider(this.selectionProductListing);
      }
      if(typeof this.playlistData != 'undefined'){
        this.querySelectorAll('[data-out-playlist-name]').forEach(item => {
          item.textContent = this.playlistData.playlist_title;
        });
      }
      // update playlist price logic
      const comparePrice = this.totalProductPrice;
      const discountPrice = this.discountedPrice;
      this.summaryStepContainer.querySelectorAll('[data-playlist-compare-price]').forEach(item => {
        item.textContent = theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat);
      });
      this.summaryStepContainer.querySelectorAll('[data-playlist-price]').forEach(item => {
        item.textContent = theme.Currency.formatMoney(discountPrice, theme.settings.moneyFormat);
      });
    }

    summaryQuantityUpdate(){
      // update quantity logic
      if(this.summaryStepContainer){
        const quantityElements = Array.from(this.summaryStepContainer.querySelectorAll('[data-bag-quantity]'));
        if (quantityElements.length > 0) {
          quantityElements.forEach(item => {
            item.textContent = this.bagQuantity;
          });
        }
      }
    }
    preparePlaylistHtml(selectionProductObject) {
      return selectionProductObject.map((item, index) => `
        <div class="playlist-slider-item" data-slide-index="${index}">
          <div class="playlist-slider-item-inner">
            <div class="playlist-slider-item-image">
              <img src="${item.featured_image}" alt="${item.title}" loading="lazy">
            </div>
            <div class="playlist-slider-item-content text-left font-bold lg:mt-5 mt-4 uppercase text-sm lg:text-base">
              <p>${item.title}</p>
            </div>
          </div>
        </div>
      `).join('')
    }
    intSlider(productListing) {
      this.playlistSliderContainer = this.summaryStepContainer.querySelector('[data-playlist-container]');
      if(typeof this.selectionProductListing != 'undefined'){
        if(this.selectionProductListing.length == 0){
          this.playlistSliderContainer.innerHTML = `No Products Found Based On Your Selection`;
          this.checkoutPlaylistButton.forEach(item => {
            item.disabled = true;
          });
        }
        else{
          this.checkoutPlaylistButton.forEach(item => {
            item.disabled = false;
          });
          this.playlistSliderContainer.innerHTML = `<flow-playlist-slider class="playlist-slider block">${this.preparePlaylistHtml(productListing)}</flow-playlist-slider>`;
        }
      }
      
    }
    // quantity step handler
    handleQuantityStepChange(event) {
      this.bagQuantity = event.target.value;
      const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
      if(!this.completedSteps.includes(slideIndex)){
        this.completedSteps.push(slideIndex);
      }
      this.verticalSlider.handleNextSlide();
      this.discountValue = event.target.getAttribute('data-discount-value');
      this.rangeInput.setAttribute('max', this.bagQuantity);
      if(this.roastType){
        this.updateBrewTypeSelection(this.roastType);
      }
      this.rangeInput.dispatchEvent(new Event('input'));
      this.summaryQuantityUpdate();
    }
    handleFrequencyStepChange(event) {
      this.frequency = { value: event.target.value, type: "weeks" };
      const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
      this.completedSteps.push(slideIndex);
      this.verticalSlider.handleNextSlide();
      this.prepareSummary();
    }
    handleBrewTypeStepChange(event) {
      this.roastType = event.target.value;
      const srollHeightElement = event.target.closest('[data-brew-type-step]');
      const srollHeight = srollHeightElement.offsetHeight;
      if (this.roastType == "mix") {
        this.brewTypeStepContainer.querySelector('.subscription-flow-body-footer').classList.add('visibility-show');
        // srollHeightElement.scrollTo({
        //   top: srollHeight,
        //   behavior: "smooth"
        // });
        window.smoothScroll(this.brewTypeStepContainer, srollHeight,2000);
        this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step-heading]').classList.remove('hidden');
        this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').classList.remove('hidden');
        this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').classList.remove('hidden');
      }
      else {
        switch (this.roastType) {
          case "espresso":
            this.espressoCount = parseInt(this.bagQuantity);
            this.filterCount = 0;
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step-heading]').classList.add('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').classList.add('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').classList.remove('hidden');
  
            break;
          case "filter":
            this.espressoCount = 0;
            this.filterCount = parseInt(this.bagQuantity);
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step-heading]').classList.remove('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').classList.remove('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').classList.add('hidden');
            break;
        }
        this.brewTypeStepContainer.querySelector('[data-espresso-count]').textContent = this.espressoCount;
        this.brewTypeStepContainer.querySelector('[data-filter-count]').textContent = this.filterCount;
        this.rangeInput.value = this.filterCount;
        this.rangeInput.dispatchEvent(new Event('input'));
        const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
        this.completedSteps.push(slideIndex);
        this.verticalSlider.handleNextSlide();
        this.brewTypeStepContainer.querySelector('.subscription-flow-body-footer').classList.remove('visibility-show');
        this.brewTypeStepContainer.querySelector('.subscription-flow-body-footer').classList.add('visibility-hide');
        // this.brewTypeStepContainer.querySelector('.subscription-flow-body-footer').classList.add('hidden');
      }
    }
    updateBrewTypeSelection(brewType){
      if(brewType == "mix"){
  
      }
      else{
        switch (brewType) {
          case "espresso":
            this.espressoCount = parseInt(this.bagQuantity);
            this.filterCount = 0;
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step-heading]').classList.add('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').classList.add('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').classList.remove('hidden');
  
            break;
          case "filter":
            this.espressoCount = 0;
            this.filterCount = parseInt(this.bagQuantity);
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step-heading]').classList.remove('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').classList.remove('hidden');
            this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').classList.add('hidden');
            break;
        }
      }
    }
    handleRangeInputChange(event) {
      this.filterCount = parseInt(event.target.value);
      this.espressoCount = parseInt(this.bagQuantity) - this.filterCount;
  
      this.brewTypeStepContainer.querySelector('[data-espresso-count]').textContent = this.espressoCount;
      this.brewTypeStepContainer.querySelector('[data-filter-count]').textContent = this.filterCount;
      this.brewTypeSelectionData.espresso = this.espressoCount;
      this.brewTypeSelectionData.filter = this.filterCount;
      this.prepareSummary();
    }
    handleGrindPreferencesConsentStepChange(event) {
      this.grindPreferences.consent = event.target.value;
      if (this.grindPreferences.consent == "yes") {
        // this.grindPreferencesStepContainer.querySelector('.subscription-flow-body-main-content-footer').classList.remove('hidden');
        this.grindPreferencesStepContainer.querySelector('.subscription-flow-body-main-content-footer').classList.add('grind-filter-visiblility-show');
        const srollHeight = this.grindPreferencesStepContainer.querySelector('.subscription-flow-body-main-content-footer').offsetHeight;
        window.smoothScroll(this.grindPreferencesStepContainer, 1000,2000);
      }
      else {
        this.grindPreferencesStepContainer.querySelector('[data-grind-filter-espresso-step]').querySelectorAll('input').forEach(input => {
          input.checked = false;
        });
        this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').querySelectorAll('input').forEach(input => {
            input.checked = false;
          });
        // this.grindPreferencesStepContainer.querySelector('.subscription-flow-body-main-content-footer').classList.add('hidden');
        this.grindPreferencesStepContainer.querySelector('.subscription-flow-body-main-content-footer').classList.remove('grind-filter-visiblility-show');
        const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
        this.completedSteps.push(slideIndex);
        this.verticalSlider.handleNextSlide();
        this.grindSelectionObject = { filter:"whole-beans", espresso:"whole-beans" };
      }
      this.prepareSummary();
  
    }
    handleGrindFilterEspressoStepChange(event) { 
     if(this.roastType == "mix"){
        if(this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').querySelectorAll('input:checked').length == 1){
          this.grindPreferences.filter = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').querySelectorAll('input:checked')[0].value;
          this.grindSelectionObject.filter = this.grindPreferences.filter;
        }
        if(this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').querySelectorAll('input:checked').length == 1){
          this.grindPreferences.espresso = this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').querySelectorAll('input:checked')[0].value;
          this.grindSelectionObject.espresso = this.grindPreferences.espresso;
        }
        const filterInputs = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-espresso-step]').querySelectorAll('input:checked');
        if(filterInputs.length < 2){return;}
        const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
        if(!this.completedSteps.includes(slideIndex)){
          this.completedSteps.push(slideIndex);
        }
        this.verticalSlider.handleNextSlide();
      
     }
     else if(this.roastType == "espresso"){       
        this.grindPreferences.filter = null;
       
        if(this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').querySelectorAll('input:checked').length == 1){
          this.grindPreferences.espresso = this.grindPreferencesStepContainer.querySelector('[data-grind-espresso-step]').querySelectorAll('input:checked')[0].value;
          this.grindSelectionObject.espresso = this.grindPreferences.espresso;
        }
        const filterInputs = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-espresso-step]').querySelectorAll('input:checked');
        if(filterInputs.length == 0){return;}
        const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
        if(!this.completedSteps.includes(slideIndex)){
          this.completedSteps.push(slideIndex);
        }
        this.verticalSlider.handleNextSlide();
       
      
     }
     else if(this.roastType == "filter"){
        this.grindPreferences.espresso = null;
        if(this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').querySelectorAll('input:checked').length == 1){
          this.grindPreferences.filter = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-step]').querySelectorAll('input:checked')[0].value;
          this.grindSelectionObject.filter = this.grindPreferences.filter;
        }
        const filterInputs = this.grindPreferencesStepContainer.querySelector('[data-grind-filter-espresso-step]').querySelectorAll('input:checked');
        if(filterInputs.length == 0){return;}
        const slideIndex = parseInt(event.target.closest('[data-slide]').getAttribute('data-slide-index'));
        if(!this.completedSteps.includes(slideIndex)){
          this.completedSteps.push(slideIndex);
        }
        this.verticalSlider.handleNextSlide();
     }
      this.prepareSummary();
    }
  }
  
  customElements.define('subscription-flow', SubscriptionFlow);